<template>
<fragment>
    <div v-if="part==='home'" class="w-full h-screen flex flex-col items-center justify-between">
        <div class="flex flex-wrap w-full overflow-y-auto">
            <div class="w-full py-4 px-4 border-b border-gray-200 flex flex-row justify-center sticky top-0">
                <div>Move ASSET</div>
            </div>
            <div class="w-full h- py-4 px-4 border-b border-gray-200 flex flex-row justify-between">
                <div>Slot</div>
                <div class="font-bold text-indigo-600" @click="forSlot()">{{itemName(slotName(slot), 'Select')}}</div>
            </div>
            <div class="w-full h- py-4 px-4 border-b border-gray-200 flex flex-row justify-between">
                <div>Asset</div>
                <div class="font-bold text-indigo-600" @click="forAsset()">{{itemName(assetName(asset), 'Scan')}}</div>
            </div>
            <div class="w-full h- py-4 px-4 border-b border-gray-200 flex flex-row justify-between">
                <div>Box</div>
                <div class="font-bold text-indigo-600" @click="forBox()">{{itemName(box, 'Scan')}}</div>
            </div>
            <div class="w-full h- py-4 px-4 border-b border-gray-200 flex flex-row justify-between">
                <div>Damages</div>
                <div class="font-bold text-indigo-600">Select</div>
            </div>
            <div class="w-full h- py-4 px-4 border-b border-gray-200 flex flex-row justify-between">
                <div>Flags</div>
                <div class="font-bold text-indigo-600">Select</div>
            </div>
            <div class="w-full h- py-4 px-4 flex flex-row justify-center">
                <button @click="back" class="bg-indigo-600 mb-2 p-2 px-16 text-white rounded-lg">Move</button>
            </div>
            <div></div>
        </div>
        <div class="py-2 border-t border-gray-200 bg-white w-full text-center">
            <button @click="back" class="bg-gray-200 mb-2 p-2 px-16 text-indigo-700 rounded-lg focus:bg-indigo-200">Back</button>
        </div>
    </div>
    <Slot v-if="part==='slot'" v-on:back="part='home'" v-on:slot="selectSlot"></Slot>
    <Asset v-if="part==='asset'" v-on:back="part='home'" v-on:asset="selectAsset"></Asset>
    <Box v-if="part==='box'" v-on:back="part='home'" v-on:asset="selectBox"></Box>
</fragment>
</template>

<script>
    import Slot from './Slot.vue'
    import Asset from './Asset.vue'
    import Box from './Box.vue'
    import {assetName, slotName} from "../library/common";

    export default {
        name: "Move",
        components : {
            Slot,
            Asset,
            Box,
        },
        data: function() {
            return {
                qrCode: '',
                slot: null,
                asset: null,
                box: null,
                part: 'home'
            }
        },
        methods: {
            back() {
                this.$emit("back")
            },
            forSlot() {
                this.part = 'slot';
            },
            forAsset() {
                this.part = 'asset';
            },
            forBox() {
                this.part = 'box';
            },
            selectSlot(slot) {
                this.part = 'home';
                this.slot = slot;
            },
            selectAsset(asset) {
                this.part = 'home';
                this.asset = asset;
            },
            selectBox(box) {
                this.part = 'home';
                this.box = box;
            },
            assetName(asset) {
                return assetName(asset);
            },
            slotName(slot) {
                return slotName(slot);
            },
            itemName(item, def) {
                if(item===null) return def;
                return item;
            }
        }
    }
</script>

<style scoped>

</style>